import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
} from "@mui/material";
import type { ShareTemplate } from "../../../configurations/share-messages/types/share-template.types";

interface Props {
  open: boolean;
  templates: ShareTemplate[];
  selectedTemplateId?: string;
  saving: boolean;
  onClose: () => void;
  onSelect: (template: ShareTemplate) => void;
}

export default function SelectInternetAgreementDialog({
  open,
  templates,
  selectedTemplateId,
  saving,
  onClose,
  onSelect,
}: Props) {
  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Choose agreement template</DialogTitle>
      <DialogContent>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Select the agreement that should be used for this stream.
        </Typography>
        <Box sx={{ display: "grid", gap: 1.5 }}>
          {templates.map((template) => {
            const selected = template.id === selectedTemplateId;
            return (
              <Paper
                key={template.id}
                variant="outlined"
                sx={{ p: 2, borderColor: selected ? "primary.main" : "divider" }}
              >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography fontWeight={700}>{template.name}</Typography>
                    <Box sx={{ display: "flex", gap: 1, mt: 0.75 }}>
                      {template.is_default_template && <Chip label="Default" size="small" />}
                      {selected && <Chip label="Currently selected" color="primary" size="small" />}
                    </Box>
                  </Box>
                  <Button
                    variant={selected ? "outlined" : "contained"}
                    disabled={saving}
                    onClick={() => onSelect(template)}
                    aria-label={`Use ${template.name}`}
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    {selected ? "Open" : "Use template"}
                  </Button>
                </Box>
              </Paper>
            );
          })}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
